/* Souq shared helpers — Phase 18 */
import { useEffect, useState } from "react";

export const SAR = (n, lang) => `${Number(n || 0).toLocaleString("en")} ${lang === "ar" ? "ر.س" : "SAR"}`;

export function useNow(interval = 30000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => { const i = setInterval(() => setNow(Date.now()), interval); return () => clearInterval(i); }, [interval]);
  return now;
}

export function remainingLabel(endsAt, now, t) {
  const ms = new Date(endsAt).getTime() - now;
  if (ms <= 0) return t("souq.ended");
  const m = Math.floor(ms / 60000), d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60;
  if (d > 0) return `${d}${t("souq.u.d")} ${h}${t("souq.u.h")}`;
  if (h > 0) return `${h}${t("souq.u.h")} ${mm}${t("souq.u.m")}`;
  return `${Math.max(mm, 1)}${t("souq.u.m")}`;
}

export async function downloadAuthed(url, filename, headers) {
  const res = await fetch(url, { headers });
  if (!res.ok) throw new Error(String(res.status));
  const blob = await res.blob();
  const href = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(href);
}

export const isEndingSoon = (endsAt, now) => new Date(endsAt).getTime() - now < 24 * 3600 * 1000;
